import {
  getAllIndustries,
  getIndustryBySlug,
  getIndustryPage,
} from "@/api/actions/industry-actions";
import { createQueryKeys } from "@lukemorales/query-key-factory";

export const industryQuery = createQueryKeys("industries", {
  // Get all the industries
  all: () => ({
    queryKey: [{}],
    queryFn: () =>
      getAllIndustries({
        populate: "deep,1",
        sort: "publishedAt:DESC",
      }),
  }),
  // Get particular industry data
  get: (slug: string) => {
    const queryParams = {
      filters: { slug: { $eq: slug } },
      populate: "deep,6",
    };

    return {
      queryKey: [queryParams],
      queryFn: () => getIndustryBySlug(queryParams),
    };
  },

  // Get Industry page data
  getIndustry: () => ({
    queryKey: [{}],
    queryFn: () => getIndustryPage({ populate: "deep,4" }),
  }),
});
